      /* COD Form v2 — quantity sent in Offer field */
      /*********** مراجع أساسية ***********/
      const form = document.forms['google-sheet'];
      const btn  = document.getElementById('btnSubmitMain');
      const scrollContainer = document.getElementById('scrollContainer');

      /*********** Auto-fill from URL params (retargeting) ***********/
      (function autoFillFromURL(){
        try {
          const params = new URLSearchParams(window.location.search);
          const map = {
            'name': 'Sa-Name', 'fname': 'Sa-Name', 'first_name': 'Sa-Name',
            'phone': 'Sa-Phone', 'tel': 'Sa-Phone',
            'wilaya': 'Sa-Wilaya', 'city': 'Sa-Wilaya',
            'address': 'Sa-Address', 'addr': 'Sa-Address'
          };
          Object.keys(map).forEach(key => {
            const val = params.get(key);
            if (!val) return;
            const fieldName = map[key];
            const el = form && form.elements[fieldName];
            if (el && !el.value) el.value = decodeURIComponent(val);
          });
        } catch(e){}
      })();

      /*********** Smart form flow — Enter advances to next field ***********/
      (function smartFormFlow(){
        if (!form) return;
        const inputs = form.querySelectorAll('input:not([type=hidden]):not([type=submit]):not([type=radio]), select');
        inputs.forEach((el, idx) => {
          el.addEventListener('keydown', function(e){
            if (e.key === 'Enter' && el.tagName !== 'TEXTAREA') {
              e.preventDefault();
              const next = inputs[idx + 1];
              if (next) next.focus();
              else if (btn) btn.focus();
            }
          });
        });
      })();

      /*********** Browser tab engagement — bring user back ***********/
      (function tabEngagement(){
        const orig = document.title;
        const teaser = '🛒 لا تفوّت العرض — اطلب الآن!';
        let interval;
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'hidden') {
            let toggle = false;
            interval = setInterval(() => {
              document.title = (toggle = !toggle) ? teaser : orig;
            }, 1500);
          } else {
            if (interval) clearInterval(interval);
            document.title = orig;
          }
        });
      })();

      /*********** Quantity stepper ***********/
      let currentQty = 1;
      const qtyValEl = document.getElementById('qtyVal');
      const hiddenQtyEl = document.getElementById('hiddenQty');
      const hiddenOfferEl = document.getElementById('hiddenOffer');
      function setQty(n){
        currentQty = Math.max(1, Math.min(20, n));
        if (qtyValEl) qtyValEl.textContent = currentQty;
        if (hiddenQtyEl) hiddenQtyEl.value = currentQty;
        if (hiddenOfferEl) hiddenOfferEl.value = currentQty;
        updateStickyPrice();
      }
      document.querySelectorAll('[data-qty-action]').forEach(b => {
        b.addEventListener('click', () => {
          const action = b.getAttribute('data-qty-action');
          setQty(currentQty + (action === 'inc' ? 1 : -1));
        });
      });

      /*********** Sticky price update (qty × unit price) ***********/
      const unitPriceEl = document.getElementById('SaUnitPrice');
      const UNIT_PRICE = unitPriceEl ? parseFloat(unitPriceEl.value) || 0 : 0;
      const wilayaInput = document.getElementById('Wilaya');

      function updateStickyPrice(){
        var stickyPrice = document.getElementById('stickyBtnPrice');
        var totalInput  = document.getElementById('SaTotal');
        var total = UNIT_PRICE * currentQty;
        if (stickyPrice && UNIT_PRICE > 0) {
          stickyPrice.textContent = 'دج ' + total;
        }
        if (totalInput) totalInput.value = total;
      }
      setTimeout(updateStickyPrice, 50);

      const phoneInput   = document.getElementById('SaPhone');
      const phoneDigitsI = document.getElementById('SaPhoneDigits');
      const phoneErrorEl = document.getElementById('phoneErrorMessage');
      const phoneHelpEl  = document.getElementById('phoneHelperMessage');

      let pageLoadTime    = Date.now();
      let lastInteraction = Date.now();
      let formSubmitted   = false;
      let abandonedSent   = false;
      let lastDraftHash   = '';
      let lastAttemptHash = '';
      let hasStarted      = false;

      /*********** IDs ***********/
      function safeUUID() {
        if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
        return 'id_' + Math.random().toString(36).slice(2) + '_' + Date.now().toString(36);
      }

      function getSessionId() {
        try {
          const key = 'sa_session_id_v1';
          let sid = sessionStorage.getItem(key);
          if (!sid) {
            sid = safeUUID();
            sessionStorage.setItem(key, sid);
          }
          return sid;
        } catch (e) {
          return safeUUID();
        }
      }

      const SESSION_ID = getSessionId();
      const sessionIdInput = document.getElementById('saSessionId');
      if (sessionIdInput) sessionIdInput.value = SESSION_ID;

      function newEventId() {
        return safeUUID();
      }

      /*********** Phone helpers — Algerian validation ***********/
      function extractDigits(str) {
        // Strip everything except digits, then strip +213/00213/213 prefix
        let d = String(str || '').replace(/\D/g, '');
        if (d.startsWith('00213')) d = d.substring(5);
        else if (d.startsWith('213') && d.length >= 11) d = d.substring(3);
        // Ensure leading 0 for local format
        if (d.length === 9 && /^[567]/.test(d)) d = '0' + d;
        return d;
      }

      function isValidAlgerianPhone(digits) {
        return /^0[567]\d{8}$/.test(digits);
      }

      function updatePhoneUI() {
        const raw = phoneInput ? phoneInput.value : '';
        const digits = extractDigits(raw);

        if (phoneDigitsI) phoneDigitsI.value = digits;

        if (digits.length > 0) {
          hasStarted = true;
          if (phoneHelpEl) phoneHelpEl.style.display = 'block';

          if (isValidAlgerianPhone(digits)) {
            phoneInput.style.borderColor = '#16a34a';
            if (phoneErrorEl) phoneErrorEl.style.display = 'none';
            if (phoneHelpEl) { phoneHelpEl.textContent = '✓ رقم صحيح'; phoneHelpEl.style.color = '#16a34a'; phoneHelpEl.style.background = '#f0fdf4'; phoneHelpEl.style.borderColor = '#86efac'; }
          } else if (digits.length < 10) {
            phoneInput.style.borderColor = '#dc3545';
            if (phoneHelpEl) { phoneHelpEl.textContent = 'تأكد من أن رقم الهاتف 10 أرقام'; phoneHelpEl.style.color = '#7a5b00'; phoneHelpEl.style.background = '#fff3cd'; phoneHelpEl.style.borderColor = '#ffe7a3'; }
          } else {
            phoneInput.style.borderColor = '#dc3545';
            if (phoneErrorEl) phoneErrorEl.style.display = 'block';
          }
        } else {
          if (phoneHelpEl) phoneHelpEl.style.display = 'none';
          phoneInput.style.borderColor = '';
          if (phoneErrorEl) phoneErrorEl.style.display = 'none';
        }
      }

      function showPhoneRequiredError() {
        if (phoneErrorEl) phoneErrorEl.style.display = 'block';
        if (phoneHelpEl) phoneHelpEl.style.display = 'block';
        if (phoneInput) {
          phoneInput.style.borderColor = '#dc3545';
          phoneInput.focus();
        }
      }

      function hasPhoneForSending() {
        const digits = extractDigits(phoneInput ? phoneInput.value : '');
        if (phoneDigitsI) phoneDigitsI.value = digits;
        return isValidAlgerianPhone(digits);
      }

      if (phoneInput) {
        phoneInput.addEventListener('input', updatePhoneUI);
        phoneInput.addEventListener('blur', function() {
          updatePhoneUI();

          if (!extractDigits(phoneInput.value).length && phoneInput.value.trim().length > 0) {
            phoneInput.style.borderColor = '#dc3545';
          }
        });
      }

      /*********** التاريخ + الرابط + GCLID/WBRAID/GBRAID للأوفلاين فقط ***********/
      (function initDateTimeAndSource() {
        var now = new Date();
        var year   = now.getFullYear();
        var month  = String(now.getMonth() + 1).padStart(2, '0');
        var day    = String(now.getDate()).padStart(2, '0');
        var hours  = String(now.getHours()).padStart(2, '0');
        var minute = String(now.getMinutes()).padStart(2, '0');
        var second = String(now.getSeconds()).padStart(2, '0');
        var dateTimeStr = year + '-' + month + '-' + day + ' ' + hours + ':' + minute + ':' + second;

        var dtInput = document.getElementById('datetime');
        if (dtInput) dtInput.value = dateTimeStr;

        var urlInput = document.getElementById('campaignUrl');
        if (urlInput) urlInput.value = window.location.href;

        var gclidInput = document.getElementById('gclid');
        if (gclidInput) {
          var params = new URLSearchParams(window.location.search || '');
          var gclid  = params.get('gclid') || params.get('gclid_aw') || params.get('gcl_aw') || '';
          var wbraid = params.get('wbraid') || '';
          var gbraid = params.get('gbraid') || '';

          if (!gclid && (wbraid || gbraid)) gclid = wbraid || gbraid;

          gclidInput.value = gclid || '';
        }
      })();

      /*********** تتبع السلوك الداخلي فقط: لا يرسل أحداث Google/Facebook ***********/
      let mouseMoveCount      = 0;
      let mouseTotalDistance  = 0;
      let lastMouseX          = null;
      let lastMouseY          = null;

      let scrollCount         = 0;
      let scrollTotalDistance = 0;
      let scrollMaxDepth      = 0;
      let lastScrollY         = window.scrollY || window.pageYOffset || 0;
      let lastScrollTime      = Date.now();
      let scrollLongestPause  = 0;

      let focusCount          = 1;

      function getDeviceType() {
        const ua = (navigator.userAgent || navigator.vendor || window.opera || '').toLowerCase();
        const width = window.innerWidth || document.documentElement.clientWidth || screen.width;

        if (/mobile|android|iphone|ipod/.test(ua) || width <= 768) return 'mobile';
        if (/ipad|tablet/.test(ua) || (width > 768 && width <= 1024)) return 'tablet';
        return 'desktop';
      }

      const deviceType  = getDeviceType();
      const viewportW   = window.innerWidth  || document.documentElement.clientWidth  || screen.width;
      const viewportH   = window.innerHeight || document.documentElement.clientHeight || screen.height;
      const screenW     = (window.screen && window.screen.width)  ? window.screen.width  : viewportW;
      const screenH     = (window.screen && window.screen.height) ? window.screen.height : viewportH;
      const dpr         = window.devicePixelRatio || 1;
      const browserLang = navigator.language || '';
      const userAgent   = navigator.userAgent || '';

      let networkType = '';
      if (navigator.connection && navigator.connection.effectiveType) {
        networkType = navigator.connection.effectiveType;
      }

      function updateLastInteraction() {
        lastInteraction = Date.now();
      }

      ['input', 'change', 'click', 'scroll', 'mousemove', 'touchstart', 'touchmove'].forEach(function(evt) {
        document.addEventListener(evt, updateLastInteraction, true);
      });

      document.addEventListener('mousemove', function(e) {
        mouseMoveCount++;

        if (lastMouseX !== null && lastMouseY !== null) {
          const dx = e.clientX - lastMouseX;
          const dy = e.clientY - lastMouseY;
          mouseTotalDistance += Math.sqrt(dx * dx + dy * dy);
        }

        lastMouseX = e.clientX;
        lastMouseY = e.clientY;
      }, { passive: true });

      window.addEventListener('scroll', function() {
        scrollCount++;

        const docHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
        const vpHeight  = window.innerHeight || document.documentElement.clientHeight;
        const maxScrollable = docHeight - vpHeight;

        if (maxScrollable > 0) {
          const depth = window.scrollY / maxScrollable;
          if (depth > scrollMaxDepth) scrollMaxDepth = depth;
        }

        const now = Date.now();
        const pause = now - lastScrollTime;

        if (pause > scrollLongestPause) scrollLongestPause = pause;

        lastScrollTime = now;

        const currentY = window.scrollY || window.pageYOffset || 0;
        const dy = Math.abs(currentY - lastScrollY);

        scrollTotalDistance += dy;
        lastScrollY = currentY;
      }, { passive: true });

      function getTimeStaySeconds() {
        return Math.round((Date.now() - pageLoadTime) / 1000);
      }

      function getBehaviorMetrics() {
        const scrollAvgSpeed = scrollCount > 0 ? Math.round(scrollTotalDistance / scrollCount) : 0;

        return {
          'Sa-Time-Stay':             getTimeStaySeconds().toString(),
          'Sa-Mouse-Move-Count':      mouseMoveCount.toString(),
          'Sa-Mouse-Total-Distance':  Math.round(mouseTotalDistance).toString(),
          'Sa-Scroll-Count':          scrollCount.toString(),
          'Sa-Scroll-Total-Distance': scrollTotalDistance.toString(),
          'Sa-Scroll-Max-Depth':      scrollMaxDepth.toFixed(2),
          'Sa-Scroll-Longest-Pause':  scrollLongestPause.toString(),
          'Sa-Scroll-Avg-Speed':      scrollAvgSpeed.toString(),
          'Sa-Device-Type':           deviceType,
          'Sa-Viewport-W':            viewportW.toString(),
          'Sa-Viewport-H':            viewportH.toString(),
          'Sa-Screen-W':              screenW.toString(),
          'Sa-Screen-H':              screenH.toString(),
          'Sa-DPR':                   dpr.toString(),
          'Sa-Browser-Lang':          browserLang,
          'Sa-User-Agent':            userAgent,
          'Sa-Network-Type':          networkType,
          'Sa-Focus-Count':           focusCount.toString()
        };
      }

      /*********** بناء FormData + IDs ***********/
      function buildFD(stage) {
        const fd = new FormData(form);

        fd.set('Sa-Lead-Stage', stage);

        const stageInput = document.getElementById('leadStage');
        if (stageInput) stageInput.value = stage;

        const eventId = newEventId();

        fd.set('Sa-Session-Id', SESSION_ID);
        fd.set('Sa-Event-Id', eventId);

        const eidInput = document.getElementById('saEventId');
        if (eidInput) eidInput.value = eventId;

        const digits = extractDigits(phoneInput ? phoneInput.value : '');
        fd.set('Sa-Phone-Digits', digits);

        // Explicitly send quantity in BOTH "Quantity" and "Offer" fields
        fd.set('Quantity', String(currentQty));
        fd.set('Offer', String(currentQty));

        const metrics = getBehaviorMetrics();
        Object.keys(metrics).forEach(function(k) {
          fd.set(k, metrics[k]);
        });

        const timeStayInput = document.getElementById('timeStay');
        if (timeStayInput) timeStayInput.value = metrics['Sa-Time-Stay'] || '';

        fd.set('Sa-Client-ISOTime', new Date().toISOString());

        return fd;
      }

      function fdToURLEncoded(fd) {
        const params = new URLSearchParams();

        fd.forEach(function(v, k) {
          params.append(k, v);
        });

        return params.toString();
      }

      /*********** إرسال إلى Google Sheet فقط ***********/
      function sendViaBeaconOrKeepalive(fd) {
        try {
          const body = fdToURLEncoded(fd);

          if (navigator.sendBeacon) {
            const blob = new Blob([body], { type: 'application/x-www-form-urlencoded' });
            return navigator.sendBeacon(APPS_SCRIPT_URL, blob);
          }

          fetch(APPS_SCRIPT_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body,
            keepalive: true
          });

          return true;
        } catch (e) {
          return false;
        }
      }

      /*********** Queue لإعادة الإرسال عند الفشل ***********/
      function getQueue() {
        try {
          return JSON.parse(localStorage.getItem('sa_failed_queue_v1') || '[]');
        } catch(e) {
          return [];
        }
      }

      function setQueue(q) {
        try {
          localStorage.setItem('sa_failed_queue_v1', JSON.stringify(q));
        } catch(e) {}
      }

      function queueFD(fd) {
        const obj = {};

        fd.forEach((v, k) => {
          obj[k] = v;
        });

        obj.__queuedAt = Date.now();

        const q = getQueue();
        q.push(obj);
        setQueue(q);
      }

      async function retryQueue(max = 5) {
        const q = getQueue();

        if (!q.length) return;

        let sent = 0;
        const remain = [];

        for (let i = 0; i < q.length; i++) {
          if (sent >= max) {
            remain.push(q[i]);
            continue;
          }

          const item = q[i];

          try {
            const params = new URLSearchParams();

            Object.keys(item).forEach(k => {
              if (k === '__queuedAt') return;
              params.append(k, item[k]);
            });

            const res = await fetch(APPS_SCRIPT_URL, {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
              body: params.toString()
            });

            if (res && res.ok) {
              sent++;
            } else {
              remain.push(item);
            }
          } catch(e) {
            remain.push(item);
          }
        }

        setQueue(remain);
      }

      window.addEventListener('online', function() {
        retryQueue(10);
      });

      /*********** Retry للـ Submitted ***********/
      function submitWithRetry(fd, attempt = 0) {
        const MAX = 3;
        const DELAY = 1500;

        return fetch(APPS_SCRIPT_URL, { method: 'POST', body: fd })
          .then(function(res) {
            if (!res || !res.ok) throw new Error('Server error');
            return true;
          })
          .catch(function(err) {
            if (attempt < MAX) {
              return new Promise(function(resolve) {
                setTimeout(function() {
                  resolve(submitWithRetry(fd, attempt + 1));
                }, DELAY);
              });
            }

            queueFD(fd);
            throw err;
          });
      }

      /*********** Redirect to thank-you with order data in URL ***********/
      function redirectToThankYou(redirectUrl) {
        if (!redirectUrl) return;
        try {
          const params = new URLSearchParams();
          const nameVal  = (form && form['Sa-Name']) ? form['Sa-Name'].value : '';
          const phoneVal = (form && form['Sa-Phone-Digits']) ? form['Sa-Phone-Digits'].value : '';
          const wilVal   = (form && form['Sa-Wilaya']) ? form['Sa-Wilaya'].value : '';
          const prodVal  = (form && form['Sa-Product-Name']) ? form['Sa-Product-Name'].value : '';
          const qtyVal   = (form && form['Quantity']) ? form['Quantity'].value : '';
          const totalVal = document.getElementById('SaTotal') ? document.getElementById('SaTotal').value : '';
          if (nameVal)  params.set('n', nameVal);
          if (phoneVal) params.set('p', phoneVal);
          if (wilVal)   params.set('w', wilVal);
          if (prodVal)  params.set('pr', prodVal);
          if (qtyVal)   params.set('q', qtyVal);
          if (totalVal) params.set('t', totalVal);
          const sep = redirectUrl.indexOf('?') === -1 ? '?' : '&';
          window.location.href = redirectUrl + sep + params.toString();
        } catch(e) {
          window.location.href = redirectUrl;
        }
      }

      /*********** Abandoned / Attempted / Draft إلى Google Sheet فقط ***********/
      function buildHashForDraft() {
        const digits = extractDigits(phoneInput ? phoneInput.value : '');
        const name   = (form['Sa-Name']?.value || '').trim();
        const wilaya = (form['Sa-Wilaya']?.value || '').trim();
        const addr   = (form['Sa-Address']?.value || '').trim();
        const offer  = (form['Offer']?.value || '').toString();

        return [digits, name, wilaya, addr, offer].join('|');
      }

      function sendAttemptedIfNeeded() {
        if (formSubmitted) return;
        if (!hasPhoneForSending()) return;

        const h = buildHashForDraft();

        if (h && h === lastAttemptHash) return;

        lastAttemptHash = h;

        const fd = buildFD('Attempted');
        sendViaBeaconOrKeepalive(fd);
      }

      function sendAbandonedLead() {
        if (!form || formSubmitted || abandonedSent) return;
        if (!hasPhoneForSending()) return;

        const fd = buildFD('Abandoned');
        sendViaBeaconOrKeepalive(fd);

        abandonedSent = true;
      }

      function sendDraftSnapshot() {
        if (!form || formSubmitted) return;
        if (!hasPhoneForSending()) return;

        const h = buildHashForDraft();

        if (!h || h === lastDraftHash) return;

        lastDraftHash = h;

        const fd = buildFD('Draft');
        sendViaBeaconOrKeepalive(fd);
      }

      /*********** Triggers للخروج إلى Google Sheet فقط ***********/
      document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'visible') {
          focusCount++;
        } else {
          sendAbandonedLead();
        }
      });

      window.addEventListener('pagehide', function() {
        sendAbandonedLead();
      });

      window.addEventListener('beforeunload', function() {
        sendAbandonedLead();
      });

      const IDLE_THRESHOLD_MS = 120000;

      setInterval(function() {
        if (!form || formSubmitted) return;
        if (!hasPhoneForSending()) return;

        const diff = Date.now() - lastInteraction;

        if (diff > IDLE_THRESHOLD_MS) {
          sendAbandonedLead();
        }
      }, 30000);

      setInterval(function() {
        sendDraftSnapshot();
      }, 25000);

      /*********** Submit handler ***********/
      if (form && btn) {
        form.addEventListener('submit', function(e) {
          e.preventDefault();

          // Honeypot check (silent reject for bots)
          var trap = document.getElementById('Sa-Bot-Trap');
          if (trap && trap.value) { return; }

          // Time-based bot check (form filled too fast = bot)
          var timeOnPage = (Date.now() - pageLoadTime) / 1000;
          if (timeOnPage < 3) { return; }

          updatePhoneUI();

          if (!hasPhoneForSending()) {
            showPhoneRequiredError();
            return;
          }

          // Wilaya validation (free text)
          var wilayaEl = document.getElementById('Wilaya');
          var wilayaVal = wilayaEl ? wilayaEl.value.trim() : '';
          if (!wilayaVal) {
            if (wilayaEl) { wilayaEl.focus(); wilayaEl.style.borderColor = '#dc3545'; }
            return;
          }
          if (wilayaEl) wilayaEl.style.borderColor = '';

          if (!form.checkValidity()) {
            sendAttemptedIfNeeded();
            form.reportValidity();
            return;
          }

          if (formSubmitted) return;

          formSubmitted = true;

          btn.disabled = true;
          btn.classList.add('loading');
          btn.textContent = '⏳ جاري إرسال طلبيتك...';

          const fd = buildFD('Submitted');

          var networkErrEl = document.getElementById('formNetworkError');
          submitWithRetry(fd)
            .then(function() {
              btn.classList.remove('loading');
              btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" width="22" height="22"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M22 4 12 14.01l-3-3" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>✅ تم إرسال طلبك</span>';
              redirectToThankYou(THANKYOU_URL);
            })
            .catch(function(err) {
              btn.classList.remove('loading');
              btn.disabled = false;
              btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" width="22" height="22"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M22 4 12 14.01l-3-3" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>أعد المحاولة</span>';
              formSubmitted = false;
              if (networkErrEl) networkErrEl.style.display = 'block';
              sendAttemptedIfNeeded();
            });
        });
      }

      /*********** Sticky CTA — IntersectionObserver (no forced reflow) ***********/
      function scrollToForm() {
        var formDiv = document.querySelector('.Codform');
        if (formDiv) formDiv.scrollIntoView({ behavior: 'smooth' });
      }
      window.scrollToForm = scrollToForm;

      (function setupStickyCTA(){
        var formDiv = document.querySelector('.Codform');
        if (!formDiv || !scrollContainer) return;
        if (!('IntersectionObserver' in window)) return;
        var observer = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            scrollContainer.style.display = entry.isIntersecting ? 'none' : 'flex';
          });
        }, { rootMargin: '-50px 0px 0px 0px', threshold: 0 });
        observer.observe(formDiv);
      })();

      function handleScrollButton(){}
      let scrollRaf = 0;
      // (legacy scroll listener kept as no-op fallback)
      window.addEventListener('scroll', function() {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(function() {
          scrollRaf = 0;
          handleScrollButton();
        });
      }, { passive: true });

      window.addEventListener('load', function() {
        handleScrollButton();
        updatePhoneUI();
        retryQueue(10);
      });

      /*********** Product sticky title+price bar ***********/
      (function setupProductStickyBar(){
        var bar = document.querySelector('.product-sticky-header');
        var priceBlock = document.querySelector('.product-page-price');
        if (!bar || !priceBlock) return;
        /* Fallback for old browsers — always show */
        if (!('IntersectionObserver' in window)) {
          bar.classList.add('is-visible');
          return;
        }
        new IntersectionObserver(function(entries){
          bar.classList.toggle('is-visible', !entries[0].isIntersecting);
        }, { threshold: 0 }).observe(priceBlock);
      })();
